export default "/WebApp/dist/assets/svg/unPin.svg";